import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { PACKAGE_NAME, TEAM } from '../../common/constants';
import type {
	PostAvatarPathParams,
	ImagePickedParams,
	PostAvatarResponse,
	CropProperties,
	RefinedFetchError,
} from '../../common/types';
import { refineFetchError } from '../utils';
import { refinePostAvatarResponse } from './utils';

export const postAvatar = async (
	loadAvatarsPathParams: PostAvatarPathParams,
	imagePickedParams: ImagePickedParams,
): Promise<PostAvatarResponse> => {
	try {
		const postAvatarQueryParams: CropProperties = imagePickedParams.crop;
		const response: unknown = await fetchJson(
			`/rest/api/3/universal_avatar/type/${loadAvatarsPathParams.type}/owner/${loadAvatarsPathParams.entityId}?x=${postAvatarQueryParams.x}&y=${postAvatarQueryParams.y}&size=${postAvatarQueryParams.size}`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'image/png',
					// To prevent XSRF requests blocking the request.
					// https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-avatars/#api-rest-api-3-universal-avatar-type-type-owner-entityid-post
					'X-Atlassian-Token': 'no-check',
				},
				body: imagePickedParams.file,
			},
		);

		return refinePostAvatarResponse(response);
	} catch (error) {
		const fetchError: RefinedFetchError | undefined = refineFetchError(error);
		fireErrorAnalytics({
			error: fetchError
				? new Error(
						`post avatar failed with status code ${fetchError.statusCode}, traceId ${fetchError.traceId} and message ${fetchError.message}`,
					)
				: new Error(`post avatar failed with error ${error}`),
			meta: {
				id: 'postPriorityAvatar',
				packageName: PACKAGE_NAME,
				teamName: TEAM,
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};
